import JsonSchema, { JsonSchemaType } from '@evidentid/json-schema/interfaces/JsonSchema';
import { CriterionTemplate } from '@evidentid/tprm-portal-lib/models/decisioning/Criterion.model';

import { addEnumLabelToSchemaIfAvailable } from '@/modules/decisioning-criteria/utils/riskProfileCriteria';

// FIXME: remove unnecessary enum label fetching once schema from BE updated correctly(enumLabels in schema)
export function buildCriterionSchema(
    criterionReferences: Record<string, any>,
    referenceOrder: string[],
    template: CriterionTemplate,
): JsonSchema {
    const templateReferences = template.evaluator.references;
    return {
        type: JsonSchemaType.object,
        properties: referenceOrder.reduce(
            (accu, refKey) => {
                const enumLabelsMap = template.displayMetadata
                    .enumValues?.find((x) => x.reference === refKey)?.values;
                const refSchema = templateReferences[refKey].schema;
                const schema = (enumLabelsMap && refSchema)
                    ? addEnumLabelToSchemaIfAvailable(refSchema, enumLabelsMap)
                    : refSchema;
                return {
                    ...accu,
                    ...(criterionReferences[refKey] !== undefined &&
                        {
                            [refKey]: schema,
                        }),
                };
            },
            {},
        ),
    };
}
